import React, { useEffect, useState } from 'react';

import CopyRight from '@src/components/CopyRight';
import Header from '@src/components/Header';
import website from '@src/constants/website';
import { useSkipAnimation } from '@src/hooks/useSkipAnimation';

import AdFormats from './adFormats';
import { videoList } from './constant';
import GetInTouch from './getInTouch';
import GetInTouchWaiting from './getInTouch/getInTouchWaiting';
import Products from './products';
import Support from './supportHome';

import './index.scss';

const Home = () => {
  const [currentPage, setCurrentPage] = useState<number | string>('products');

  // 记录是否离开过 products 页面
  const skipAnimation = useSkipAnimation(currentPage, 'products');

  useEffect(() => {
    // 预加载所有视频
    const videoElements: HTMLVideoElement[] = [];
    const preloadVideos = () => {
      videoList.forEach(item => {
        const video = document.createElement('video');
        video.preload = 'auto';
        video.muted = true;
        video.src = item.video;
        video.load();
        videoElements.push(video);
      });
    };
    // 如果页面已加载完成，直接预加载；否则等待 load 事件
    if (document.readyState === 'complete') {
      preloadVideos();
    } else {
      window.addEventListener('load', preloadVideos);
    }
    // 组件卸载时清理
    return () => {
      videoElements.forEach(video => {
        video.src = '';
        video.load();
      });
      window.removeEventListener('load', preloadVideos);
    };
  }, []);
  return (
    <div className="odc-official-page-home">
      <Header
        onPageChange={(page: number | string) => {
          setCurrentPage(page);
        }}
        onLoginClick={(product: string) => {
          if (product === 'userGrowth') {
            window.location.href = website.userGrowth;
          } else if (product === 'monetization') {
            window.location.href = website.monetization;
          }
        }}
      />
      <div className="odc-official-container">
        {currentPage === 'products' && <Products skipAnimation={skipAnimation} />}
        {currentPage === 'adFormats' && <AdFormats />}
        {currentPage === 'support' && <Support />}
        {currentPage === 'getInTouch' && <GetInTouch />}
      </div>
      <CopyRight />
    </div>
  );
};

export default Home;